import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormNames } from "@/resources/constants";

import { IChangePassState, ICodeResp, IPasswordsPayload } from "./types";
import { fetchSendPhone, fetchSendCode, fetchSendNewPassword } from "./asyncActions";

const initialState: IChangePassState = {
  token: "",
  phone: "",
  email: "",
  name: "",
  code: "",
  password: "",
  passwordRepeat: "",
  showForm: "",
  isLoading: false,
  errorMessage: "",
};

const changePassSlice = createSlice({
  name: "changePass",
  initialState,
  reducers: {
    addPhone(state, action: PayloadAction<string>) {
      state.phone = action.payload;
    },
    addEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    addCode(state, action: PayloadAction<string>) {
      state.code = action.payload;
    },
    addPassword(state, action: PayloadAction<IPasswordsPayload>) {
      state.password = action.payload.password;
      state.passwordRepeat = action.payload.passwordRepeat;
    },
    setShowForm(state, action: PayloadAction<string>) {
      state.showForm = action.payload;
    },
    addName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    // Send phone
    builder
      .addCase(fetchSendPhone.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = "";
      })
      .addCase(fetchSendPhone.fulfilled, (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.showForm = action.payload;
      })
      .addCase(fetchSendPhone.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = typeof action.payload === "string" 
          ? action.payload 
          : action.error?.message || "Ошибка отправки телефона";
      });

    // Send code
    builder
      .addCase(fetchSendCode.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        fetchSendCode.fulfilled,
        (state, action: PayloadAction<ICodeResp>) => {
          state.isLoading = false;
          state.showForm = action.payload.form;
          state.token = action.payload.token;
        }
      )
      .addCase(fetchSendCode.rejected, (state) => {
        state.isLoading = false;
        state.showForm = FormNames.ERROR;
      })

    // Send new password
    builder
      .addCase(fetchSendNewPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        fetchSendNewPassword.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.isLoading = false;
          state.showForm = action.payload;
        }
      )
      .addCase(fetchSendNewPassword.rejected, (state) => {
        state.isLoading = false;
        state.showForm = FormNames.ERROR;
      });
  },
});

export const {
  addPhone,
  addCode,
  addName,
  addPassword,
  setShowForm,
  reset,
  addEmail
} = changePassSlice.actions;

export default changePassSlice.reducer;
